<template>
	<div class="header-container">
		<div class="l-content">
			<el-button style="margin-right: 20px;" @click="handMenu()"  icon="el-icon-s-unfold" size="mini"></el-button>
			<el-breadcrumb separator="/">
			  <el-breadcrumb-item  v-for="item in tage" :key="item.name" :to="{ path: item.path }" >
				<span class="mianb" >{{item.label}}</span>
			  </el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="r-content">
			<el-dropdown @command="handleCommand">
			  <span class="el-dropdown-link">
			    <img class="icon" src="../assets/img/1.jpg"/>
			  </span>
			  <el-dropdown-menu slot="dropdown">
			    <!-- <el-dropdown-item command="1">更换风格</el-dropdown-item> -->
			    <el-dropdown-item command="2">退出登录</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import {mapState} from "vuex"
	import Cookie from 'js-cookie'
	export default{
		data(){
			return{}
		},
		methods:{
			handMenu(){
				this.$store.commit('collapseMenu');
			},
			goindex(){
				this.$router.push('/home')
			},
			handleCommand(command) {
				if(command == '1'){	
					this.$store.commit('changemenucolor');
					this.$store.commit('changetextcolor');
				}else if(command =='2'){
					this.$message({
						message: '退出成功',
						type: 'success'
					});
					Cookie.remove('token')
					Cookie.remove('menu')
					// 点击方法 url为传入的第三方链接或网址
					// let path=window.location.protocol+'//chuooo.cn'
					// window.location.href=path
					this.$router.push('login')
				}
			}
		},
		computed:{
			...mapState({
				tage: state =>state.tab.tabsList
			})
		},
		mounted() {
			//console.log(this.tage);
		}
	}
	
</script>

<style lang="less" scoped>
	.header-container{
		padding: 0 20px;
		background-color: #19191e;
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.text{
			color: #fff;
			margin-left: 10px;
			font-size: 14px;
			cursor: pointer;
		}
		.l-content{
			display: flex;
			align-items: center;
			.mianb{
				font-weight: normal;
				color: #fff;
			}
			::v-deep .el-breadcrumb__item{
				 .el-breadcrumb__inner{
					font-weight: normal;
					& .is-link{
						color: #666;
					}
				}
				&:last-child{
					.el-breadcrumb__item{
						color: #fff;
					}
				}
			}
		}
		.r-content{
			.icon{
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}
		}
	}
</style>